import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export class Session {
  constructor(sessionOptions) {
    _defineProperty(this, "sessionOptions", void 0);
    _defineProperty(this, "timeoutId", void 0);
    this.sessionOptions = sessionOptions;
  }
  update() {
    if (typeof this.timeoutId !== 'undefined') {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = setTimeout(() => {
      this.sessionOptions.callback?.();
    }, this.sessionOptions.duration);
  }
}